import React from 'react';

export const PublicLayout: React.FC = ({ children }) => <div>{children}</div>;
